// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.loading_IISeM {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.loadingContainer_Ik7pf {
  display: flex;
  align-items: center;
  gap: 10px;
  animation: zoomIn_MnCQg 2s ease-in-out forwards;
  font-size: 50px;
  backdrop-filter: blur(10px);
  text-transform: capitalize;
  font-weight: 500;

  img {
    height: 60px;
    width: 60px;
  }

  strong {
    font-size: 50px;
    font-weight: 600;
    text-transform: uppercase;
  }
}

.hiddenMobile_XmcId {
  display: flex;
  align-items: center;
  gap: 4px;
}

@media (max-width: 768px) {
  .loadingContainer_Ik7pf {
    img {
      height: 120px;
      width: 120px;
    }
  }

  .hiddenMobile_XmcId {
    display: none;
  }
}





@keyframes zoomIn_MnCQg {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(2.4);
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Loading/Loading.module.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+CAAyC;EACzC,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;;EAEhB;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE;MACE,aAAa;MACb,YAAY;IACd;EACF;;EAEA;IACE,aAAa;EACf;AACF;;;;;;AAMA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n}\n\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  animation: zoomIn 2s ease-in-out forwards;\n  font-size: 50px;\n  backdrop-filter: blur(10px);\n  text-transform: capitalize;\n  font-weight: 500;\n\n  img {\n    height: 60px;\n    width: 60px;\n  }\n\n  strong {\n    font-size: 50px;\n    font-weight: 600;\n    text-transform: uppercase;\n  }\n}\n\n.hiddenMobile {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n@media (max-width: 768px) {\n  .loadingContainer {\n    img {\n      height: 120px;\n      width: 120px;\n    }\n  }\n\n  .hiddenMobile {\n    display: none;\n  }\n}\n\n\n\n\n\n@keyframes zoomIn {\n  from {\n    transform: scale(1);\n  }\n\n  to {\n    transform: scale(2.4);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `loading_IISeM`,
	"loadingContainer": `loadingContainer_Ik7pf`,
	"zoomIn": `zoomIn_MnCQg`,
	"hiddenMobile": `hiddenMobile_XmcId`
};
export default ___CSS_LOADER_EXPORT___;
